import React, { useEffect, useRef, useContext } from 'react'
import PropTypes from 'prop-types'
import gsap from 'gsap'
import { StoreState, StoreDispatch } from '../../Store'

// Utils
import { disablePageScroll, enablePageScroll } from '../../utils/utils'

// Styles
import { MenuToggleMain, MenuToggleBar, MenuToggleWrapper } from './index.style'

const MenuToggle = ({ ready, extraDelay, scrolled, dark }) => {
  const store = useContext(StoreState)
  const { mobileNavIsOpen } = store
  const dispatch = useContext(StoreDispatch)
  const toggleRef = useRef()
  const barRefA = useRef()
  const barRefB = useRef()
  const barRefC = useRef()

  useEffect(() => {
    const tlOpen = gsap.timeline({ paused: true })
    const tlClose = gsap.timeline({ paused: true })

    tlOpen
      .to(barRefA.current, {
        y: 0,
        rotate: 45,
        duration: 0.2,
        ease: 'power2.inOut',
      })
      .to(
        barRefC.current,
        {
          y: 0,
          rotate: -45,
          duration: 0.2,
          ease: 'power2.inOut',
        },
        0
      )

    tlClose
      .to(barRefA.current, {
        y: -6,
        rotate: 0,
        duration: 0.2,
        ease: 'power2.inOut',
      })
      .to(
        barRefC.current,
        {
          y: 6,
          rotate: 0,
          duration: 0.2,
          ease: 'power2.inOut',
        },
        0
      )

    if (mobileNavIsOpen) {
      disablePageScroll()
      tlOpen.play()
    } else {
      enablePageScroll()
      tlClose.play()
    }

    return () => {
      tlOpen.kill()
      tlClose.kill()
    }
  }, [mobileNavIsOpen])

  const handleClick = () => {
    if (mobileNavIsOpen) {
      dispatch({ type: 'HIDE_MOBILE_NAV' })
    } else {
      dispatch({ type: 'SHOW_MOBILE_NAV' })
    }
  }

  return (
    <MenuToggleWrapper
      ref={toggleRef}
      ready={ready}
      extraDelay={extraDelay}
      scrolled={scrolled}
      dark={dark}
    >
      <MenuToggleMain
        onClick={handleClick}
        aria-label="Toggle menu"
        ready={ready}
        extraDelay={extraDelay}
        scrolled={scrolled}
      >
        <MenuToggleBar ref={barRefA} dark={dark} />
        <MenuToggleBar ref={barRefB} show={!mobileNavIsOpen} dark={dark} />
        <MenuToggleBar ref={barRefC} dark={dark} />
      </MenuToggleMain>
    </MenuToggleWrapper>
  )
}

MenuToggle.propTypes = {
  ready: PropTypes.bool,
  extraDelay: PropTypes.bool,
  scrolled: PropTypes.bool,
}

export default MenuToggle
